<div *ngIf="form">
    <div class="code-box_title">
        <h4 *ngIf="router.url != '/settings/idms'">{{ 'SETTING_PAGE.INFORMATE_SETTINGS.CALCULATION_PREFERENCES_TAB.PASS_PERCENTAGE' | transloco }}</h4>
        <h4 *ngIf="router.url === '/settings/idms'">{{ 'SETTING_PAGE.INFORMATE_SETTINGS.CALCULATION_PREFERENCES_TAB.TORQUE_PASS_PERCENTAGE' | transloco }}</h4>
    </div>
    <div class="card-body h-100">
        <div>
            <table [formGroup]="form" class="mat-table div-wrapper mat-table-wrapper">
                <tr class="mat-header-row">
                    <th class="mat-header-cell">{{ 'SETTING_PAGE.INFORMATE_SETTINGS.PASS_PERCENTAGE.LABALS.PASS' | transloco }}</th>
                    <th class="mat-header-celltwo">{{ 'SETTING_PAGE.IDMS_SETTINGS.TEXT' | transloco }}</th>
                    <th class="mat-header-celltwo">{{ 'SETTING_PAGE.IDMS_SETTINGS.PERCENTAGE' | transloco }}</th>
                </tr>
                <tr class="mat-row" *ngFor="let pass of passState; let i = index">
                    <td class="mat-cell">
                        <mat-checkbox
                            [checked]="pass.checked"
                            class="checkbox-wrap"
                            (change)="checkboxChange(pass, $event)"
                            [aria-label]="pass.visible.key"
                            [value]="pass.checked"
                        >
                            {{ pass.visible.name | passLabelModify }}
                        </mat-checkbox>
                    </td>
                    <td class="mat-cell">
                        <div class="pass-name-text">
                            <mat-form-field class="text-data custom-text-field" [floatLabel]="'never'">
                                <input
                                    type="text"
                                    matInput
                                    name="{{ pass.text.key }}"
                                    [formControlName]="pass.text.key"
                                    (change)="textBoxChange(pass, $event)"
                                />
                            </mat-form-field>
                            <p class="error-message" *ngIf="form.get(pass.text.key).hasError('required')">Enter some text here</p>
                        </div>
                    </td>
                    <td class="mat-cell">
                        <div class="pass-name-percentage">
                            <mat-form-field class="text-percentage custom-text-field" [floatLabel]="'never'">
                                <input
                                    [id]="i"
                                    type="number"
                                    matInput
                                    name="{{ pass.value.key }}"
                                    [formControlName]="pass.value.key"
                                    (change)="textBoxChange(pass, $event)"
                                    [readonly]="pass.index == 4"
                                />
                            </mat-form-field>
                            <span
                                class="error-message error-text-field"
                                *ngIf="form.get(pass.value.key).hasError('required') || form.get(pass.value.key).hasError('lessThanZero')"
                            >
                                Pass percentage must not be empty
                            </span>
                            <span
                                class="error-message error-text-field"
                                *ngIf="form.get(pass.value.key).hasError('max') || form.get(pass.value.key).hasError('min')"
                            >
                                Pass percentage must be 100
                            </span>
                            <span class="error-message error-text-field" *ngIf="form.get(pass.value.key).hasError('notMatch')">
                                Pass percentage must be less than pass {{ pass.index + 1 }}.
                            </span>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>
